import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export default function NoResult() {
  const { t } = useTranslation();
  return (
    <Typography variant="caption" display="block">
      {t("shared.noResult")}
    </Typography>
  );
}
